import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import config from 'src/config';
import { rateLimitErrorLink } from '../rateLimitErrorLink';

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        health: {
          merge(incoming, existing = {}) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
  },
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    rateLimitErrorLink,
    new HttpLink({ uri: [config.REACT_APP_API_URL, 'webshop'].join('/') }),
  ]),
  cache,
});

export default apolloClient;
